require('./aggregatorTinkInfoAddBank.scss');

// @vendors
import React from 'react';

// assets
import oneIcon from '../assets/one.svg';
import twoIcon from '../assets/two.svg';
import threeIcon from '../assets/three.svg';
import infoIcon from '../assets/info.svg';

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;

function AggregatorTinkInfoAddBank() {
  return (
    <div className="aggregator-info-module col-xs-12 col-md-4">
      <div className="aggregator-info-module__title">
        <h3>{formatText('aggregatorCredentialsView-infoTitle')}</h3>
      </div>
      <div className="aggregator-info-module__steps">
        <div className="aggregator-info-module__steps__first">
          <div className="aggregator-info-module__steps__first__container">
            <div>
              <img className="icon-image" src={oneIcon} />
            </div>
            <div className="text-info">{formatText('aggregatorCredentialsView-infoStep1')}</div>
          </div>
          <div>
            <img src={infoIcon} />
          </div>
        </div>
        <div className="aggregator-info-module__steps__second">
          <div>
            <img className="icon-image" src={twoIcon} />
          </div>
          <div className="text-info">{formatText('aggregatorCredentialsView-infoStep2')}</div>
        </div>
        <div className="aggregator-info-module__steps__third">
          <div>
            <img className="icon-image" src={threeIcon} />
          </div>
          <div className="text-info"> {formatText('aggregatorCredentialsView-infoStep3')}</div>
        </div>
        <div className="aggregator-info-module__faq-container">
          <FormattedText value="aggregatorCredentialsView-faq" />
        </div>
      </div>
    </div>
  );
}

export default AggregatorTinkInfoAddBank;
